export const ITEMS_PER_PAGE = 10;

export const STATUS_MAP = {
  1: 'Patient Admitted',
  2: 'Patient Denied',
  3: 'Patient in OT',
  4: 'Patient Discharged',
  5: 'Hospital Denied',
  6: 'Patient is on the Way',
  7: 'Admission in Process',
  8: 'Patient in ICU',
  9: 'Patient in HDU',
  10: 'OT is scheduled Today',
  11: 'OT Cancelled',
  12: 'OT is Completed Today',
  13: 'Patient in Ward',
  14: 'Only OPD Done',
  15: 'Discharge is scheduled Today',
};

export const TRAUMA_LABELS = {
  0: { main: 'No', sub: '' },
  1: { main: 'Yes', sub: 'Waiting for Approval' },
  2: { main: 'Yes', sub: 'Approved' },
  3: { main: 'Yes', sub: 'Rejected' },
};

export const TRAUMA_COLORS = {
  1: 'orange',
  2: 'green',
  3: 'red',
};

export const BILLING_COLORS = {
  1: '#ECAC09',
  2: 'violet',
  3: '#7225EF',
  4: '#299F5D',
  5: '#DD0000',
};

export const STATUS_COLORS = {
  0: '#DD0000',
  1: '#ECAC09',
  2: '#ECAC09',
  3: '#ECAC09',
  4: '#DD0000',
  5: '#DD0000',
  6: '#299F5D',
  7: '#ECAC09',
  8: '#299F5D',
  9: '#299F5D',
  11: '#3D3BA4',
};

export const CONCIERGE_COLORS = {
  1: '#3D3BA4',
  2: '#DD0000',
  3: '#ECAC09',
  4: '#299F5D',
  5: '#8B0000',
  6: '#1E90FF',
  7: '#9370DB',
  8: '#FF1493',
  9: '#FF4500',
  10: '#FF8C00',
  11: '#808080',
  12: '#32CD32',
  13: '#00CED1',
  14: '#8A2BE2',
  15: '#20B2AA',
};

export const STATUS_LABELS = {
  0: 'Rejected',
  1: 'Under Process',
  2: 'Discussing with Hospital',
  3: 'Discussing with Patient',
  4: 'Patient Denied',
  5: 'Hospital Denied',
  6: 'Procedure Confirmed',
  7: 'Hold',
  11: 'New',
  12: 'Waiting For Approval',
};

export const ROLE_CODES = {
  ACCADMIN: 'ACCADMIN',
  CE: 'CE',
  GROUPPRADMIN: 'GROUPPRADMIN',
};

export const BILLING_STATUS_TEXT = {
  1: 'Billing Uploaded',
  2: 'Billing Done',
  3: 'Billing Completed',
  4: 'Billing Approved',
  5: 'Billing Rejected',
};

export const STATUS_LIST = [
  { id: 0, value: 'Rejected' },
  { id: 1, value: 'Under Process' },
  { id: 4, value: 'Patient Denied' },
  { id: 5, value: 'Hospital Denied' },
  { id: 6, value: 'Procedure Confirmed' },
  { id: 12, value: 'Waiting For Approval' },
  { id: 7, value: 'Hold' },
];

export const SERVICE_TYPE_DS = [
  { id: 8, value: 'IPD' },
  { id: 9, value: 'OPD' },
  { id: 10, value: 'Investigation' },
  { id: 11, value: 'Day Care' },
  { id: 12, value: 'Physiotherapy' },

];

export const REFERRAL_LIST = [
  { value: 0, name: 'Referral' },
  { value: 1, name: 'Non-Referral' },
];

export const SUB_SERVICE_LIST = [
  { value: 1, name: 'Emergency' },
  { value: 2, name: 'Non-Emergency' },
  { value: 3, name: 'Others' },
];

export const HOSPITALIZATION_LIST = [
  { value: 1, name: 'General Surgery' },
  { value: 2, name: 'Oncology' },
  { value: 3, name: 'Neurology' },
  { value: 4, name: 'Orthopedic' },
  { value: 5, name: 'Urology' },
  { value: 6, name: 'Cardiology' },
  { value: 7, name: 'ENT' },
  { value: 8, name: 'Gynecology' },
  { value: 10, name: 'Opthalmology' },
  { value: 11, name: 'General Medicine' },
  { value: 15, name: 'Nephrology' },
];

export const HOSPITALIZATION_LIST_4 = [
  ...HOSPITALIZATION_LIST,
  { value: 12, name: 'OPD Others' },
  { value: 13, name: 'Investigation Others' },
  { value: 14, name: 'Day Care Others' },
];

export const HOSPITALIZATION_LIST_OPD = [{ value: 12, name: 'OPD Others' }];
export const HOSPITALIZATION_LIST_INVESTIGATION = [{ value: 13, name: 'Investigation Others' }];
export const HOSPITALIZATION_LIST_DAYCARE = [{ value: 14, name: 'Day Care Others' }];
export const HOSPITALIZATION_LIST_PHYSIO = [{ value: 16, name: 'Physiotherapy' }];


export const HOSPITALIZATION_OPTIONS_MAP = {
  8: HOSPITALIZATION_LIST,
  9: HOSPITALIZATION_LIST_OPD,
  10: HOSPITALIZATION_LIST_INVESTIGATION,
  11: HOSPITALIZATION_LIST_DAYCARE,
  12: HOSPITALIZATION_LIST_PHYSIO
};
